export const hasDesignId = (hash: string) => hash.match(/#(\/)?(u)?(\/)?[0-9A-Z-]{10,}$/gi);
export const hasVpcId = (hash: string) => hash.match(/#(?!\/guide)(\/)?(u)?(\/)?[a-z0-9]{4,6}$/gi);
export const getVpcId = (hash: string) => hash.match(/([a-z0-9]{4,6}$)/gi)?.[0];
export const getDesignId = (hash: string) => hash.match(/([A-Z0-9-]{10,}$)/gi)?.[0];
export const hasSprId = (hash: string) => hash.match(/#(\/)?[a-z0-9]{7,}$/gi);
export const getSprId = (hash: string) => hash.match(/([a-z0-9]{7,})/gi)?.[0];

export const getRedirectTarget = () => {
  const { hash } = new URL(window.location.href);

  if (hasDesignId(hash)) {
    return `/designId/${getDesignId(hash)}`;
  } else if (hasVpcId(hash)) {
    // http://localhost:3000/?range=pax&uiPlatform=web&locale=pt-PT#996KK7
    // http://localhost:3000/?range=pax&uiPlatform=web&locale=pt-PT#u996KK7
    return `/vpc/${getVpcId(hash)}`;
  } else if (hasSprId(hash)) {
    // http://localhost:3000/?range=pax&uiPlatform=web&locale=pt-PT#S09025727
    return `/spr/${getSprId(hash)}`;
  }
};

export const reloadPlanner = () => {
  window.location.reload();
};
